// extracted by mini-css-extract-plugin
module.exports = {"main":"Section_main___SSiz","list":"Section_list__nt_Do","listItem":"Section_listItem__BlegD","listItemCard":"Section_listItemCard__AF1_a"};